// extracted by mini-css-extract-plugin
module.exports = {"plus":"BookAddToMyBooks__plus"};